/* Step 11c-3 · lane C3c (Mars live finds, section 4.3: sampling, vouching, JE testing) — EN + AR texts.
   s11c3c.je        find 11: the J9 / J11 user-lists prompt on Journal entry testing; find 13: the drill-down Debit / Credit;
                    find 15: the Send-to-Sampling counter while the distinct count loads.
   s11c3c.sampling  find 16: the JE / worksheet population badge; finds 20 / 21: the entered size and the head filter lines;
                    find 22: the folder selector of continuous testing.
   s11c3c.vouching  find 18: the invoice-level comparison note.
   errors.*         the new refusal of find 21. */
export default {
  en: {
    s11c3c: {
      je: {
        promptTitle: "J9 and J11 need their user lists",
        promptBody: "J9 (preparer not authorised) and J11 (senior-management postings) flag nothing until the lists are set: J9 then only flags a blank preparer, J11 only a user whose name contains a senior role word. Set the lists before the scan — the names below are the users found in the GL.",
        j9Missing: "J9 authorised posters: not set",
        j11Missing: "J11 senior users: not set",
        j9Set: "J9 authorised posters: {n} set",
        j11Set: "J11 senior users: {n} set",
        loadNames: "Show the users in the GL",
        enteredBy: "Entered by",
        approvers: "Approver",
        lines: "{n} lines",
        pickHint: "Tick the names, then save them to a list.",
        saveJ9: "Save ticked as J9 authorised posters",
        saveJ11: "Save ticked as J11 senior users",
        noNames: "No user names in the GL's Entered by / Approver columns.",
        rescanHint: "Run the scan again after saving a list.",
        debit: "Debit",
        credit: "Credit",
        counting: "counting…",
      },
      sampling: {
        badgeJe: "JE population",
        badgeWs: "Worksheet",
        headFilter: "FS head {head} only: {after} of {before} lines",
        nEntered: "n {n} as entered (the MUS formula gives {f})",
        folderContinuous: "File in folder (optional)",
        folderContinuousHint: "A folder that is an FS head limits the population to that head's accounts.",
      },
      vouching: {
        invoiceLevel: "Invoice level — {n} lines of this voucher",
      },
    },
    errors: {
      SAMPLING_HEAD_POPULATION_EMPTY: "No line of this population is in the folder's FS head — the sample is drawn only from the lines whose account is mapped to that head. Choose another category (or All categories), or another folder.",
    },
  },
  ar: {
    s11c3c: {
      je: {
        promptTitle: "يحتاج J9 وJ11 إلى قوائم المستخدمين",
        promptBody: "لا يؤشر J9 (مُعِدّ غير مخوّل) ولا J11 (قيود الإدارة العليا) على أي شيء حتى تُحدَّد القوائم: عندها يؤشر J9 فقط على المُعِدّ الفارغ، ويؤشر J11 فقط على مستخدم يحتوي اسمه على كلمة دور قيادي. حدّد القوائم قبل الفحص — الأسماء أدناه هي المستخدمون الموجودون في دفتر الأستاذ.",
        j9Missing: "المخوّلون بالترحيل في J9: غير محدّدين",
        j11Missing: "المستخدمون القياديون في J11: غير محدّدين",
        j9Set: "المخوّلون بالترحيل في J9: {n} محدّد",
        j11Set: "المستخدمون القياديون في J11: {n} محدّد",
        loadNames: "عرض المستخدمين في دفتر الأستاذ",
        enteredBy: "أدخله",
        approvers: "المعتمِد",
        lines: "{n} سطر",
        pickHint: "علّم الأسماء ثم احفظها في قائمة.",
        saveJ9: "حفظ المعلَّم كمخوّلين بالترحيل في J9",
        saveJ11: "حفظ المعلَّم كمستخدمين قياديين في J11",
        noNames: "لا توجد أسماء مستخدمين في عمودَي «أدخله» و«المعتمِد» في دفتر الأستاذ.",
        rescanHint: "أعد تشغيل الفحص بعد حفظ القائمة.",
        debit: "مدين",
        credit: "دائن",
        counting: "جارٍ العدّ…",
      },
      sampling: {
        badgeJe: "مجتمع القيود",
        badgeWs: "ورقة عمل",
        headFilter: "البند {head} فقط: {after} من {before} سطر",
        nEntered: "n = {n} كما أُدخل (معادلة العينة النقدية تعطي {f})",
        folderContinuous: "الحفظ في المجلد (اختياري)",
        folderContinuousHint: "المجلد الذي يمثّل بندًا في القوائم المالية يحصر المجتمع في حسابات ذلك البند.",
      },
      vouching: {
        invoiceLevel: "على مستوى الفاتورة — {n} أسطر من هذا القيد",
      },
    },
    errors: {
      SAMPLING_HEAD_POPULATION_EMPTY: "لا يوجد أي سطر من هذا المجتمع في بند المجلد — تُسحب العينة فقط من الأسطر التي حساباتها مربوطة بذلك البند. اختر فئة أخرى (أو كل الفئات) أو مجلدًا آخر.",
    },
  },
};
